import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SharedModule} from '../shared/shared.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {EnvironmentConfiguration} from '../shared/EnvironmentConfiguration';
import {IgoService} from '../services/igo.service';
import {LoaderService} from '../services/loader.service';
import {PredictService} from '../services/predict.service';
import {PlanComponent} from './plan/plan.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {Map3dComponent} from './plan/map-3d/map-3d.component';
import {Map2dComponent} from './plan/map-2d/map-2d.component';
import { EchelleComponent } from './plan/echelle/echelle.component';
import {SvgService} from '../services/svg.service';
import {MapperService} from '../services/mapper.service';
import {CreatePlanDialogComponent} from './dashboard/create-plan.dialog.component';
import {EnjeuxComponent} from './plan/enjeux/enjeux.component';
import { CcmComponent } from './plan/ccm/ccm.component';
import { StrategieCommunaleComponent } from './plan/strategie-communale/strategie-communale.component';
import {SocketService} from '../services/socket.service';
import {DownloadService} from '../services/download.service';
import { LoginComponent } from './login/login.component';

import { LegendeComponent } from './plan/legende/legende.component';
import { CartoucheComponent } from './plan/cartouche/cartouche.component';
import {TitleDialogComponent} from './plan/title/title.dialog.component';
import { UploadDialogComponent } from './plan/upload-dialog/upload.dialog.component';
import {AuthService} from '../services/auth.service';
import {LocalParamsService} from '../services/local-params.service';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import {UnauthorizedComponent} from './unauthorized.component';
import {WrongDeviceComponent} from './wrong-device.component';
import {JwtLoginComponent} from './jwt-login.component';
import {LayerService} from '../services/layer.service';
import {CesiumEventService} from '../services/cesium-event.service';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker
} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {DatePipe, JsonPipe} from '@angular/common';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {RouterLink} from '@angular/router';
import {MatInput} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {A0ListComponent} from './dashboard/a0-list.component';
import {ModulesDynamicPosition} from './plan/map-2d/modules/module-dynamic-position.component';
import {ModuleTitleEditionComponent} from './plan/map-2d/modules/module-title-edition.component';
import {FilterByPipe} from '../shared/pipe/filter-by.pipe';
import {HighlightDirective} from '../shared/highlight.component';
import {RiskNamePipe} from '../shared/pipe/riskName.pipe';
import {RiskIconComponent} from '../shared/risk-icon.component';

@NgModule({ declarations: [
    AppComponent,
    PlanComponent,
    Map3dComponent,
    Map2dComponent,
    CreatePlanDialogComponent,
    EchelleComponent,
    EnjeuxComponent,
    CcmComponent,
    StrategieCommunaleComponent,
    LoginComponent,
    LegendeComponent,
    CartoucheComponent,
    TitleDialogComponent,
    DashboardComponent,
    UnauthorizedComponent,
    JwtLoginComponent,
    WrongDeviceComponent,
    UploadDialogComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MatDatepickerToggle,
    MatDatepicker,
    MatDatepickerInput,
    MatDateRangeInput,
    MatDateRangePicker,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    JsonPipe,
    MatMenuTrigger,
    MatMenuItem,
    DatePipe,
    RouterLink,
    MatInput,
    MatTooltipModule,
    A0ListComponent,
    ModulesDynamicPosition,
    ModuleTitleEditionComponent,
    FilterByPipe,
    HighlightDirective,
    RiskNamePipe,
    RiskIconComponent,
  ], providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
    IgoService,
    LoaderService,
    PredictService,
    SvgService,
    provideNativeDateAdapter(),
    MapperService,
    SocketService,
    DownloadService,
    AuthService,
    LayerService,
    CesiumEventService,
    LocalParamsService,

    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' }
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (http: HttpClient) => () => EnvironmentConfiguration.load(http),
      multi: true,
      deps: [HttpClient]
    },
    provideHttpClient(withInterceptorsFromDi())
  ] })
export class AppModule { }
